//entrypoint
import axios from "axios";
import { getToken } from "../utils/constants";

import store from "../redux/store";

const { dispatch } = store;

export const AXIOS_INSTANCE_WITHOUT_INTERCEPTOR = axios.create();

export async function generateHash() {
  const timestamp = Date.now().toString();
  const random = Math.random().toString();
  const hash = await crypto.subtle
    .digest("SHA-256", new TextEncoder().encode(timestamp + random))
    .then((hash) => {
      let hashArray = Array.from(new Uint8Array(hash));
      let hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
      return hashHex;
    });
  return hash;
}
AXIOS_INSTANCE_WITHOUT_INTERCEPTOR.interceptors.request.use(async (config) => {
  const token = getToken();
  config.headers["x-origin"] = "e5dadeccee37872f08f365bb82005462";

  config.headers["x-browser-fingerprint"] = localStorage.getItem(
    "fingerprint"
  );
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
AXIOS_INSTANCE_WITHOUT_INTERCEPTOR.interceptors.response.use(
  (response) => {
    const token = getToken();
    if (response.headers.authorization && token) {
      dispatch({
        type: "accountData/setToken",
        payload: response?.headers?.authorization.replace("Bearer", ""),
      });
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
    }

    return error;
  } //
);

export const AXIOS_INSTANCE = AXIOS_INSTANCE_WITHOUT_INTERCEPTOR;
